"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var tool = require("../tool");
var base_1 = require("./base");
var RadicalLine = /** @class */ (function (_super) {
    __extends(RadicalLine, _super);
    function RadicalLine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._reservedAttr = ["x1", "y1", "x2", "y2"];
        return _this;
    }
    RadicalLine.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_r1":
            case "_r2":
            case "_y1":
            case "_y2":
                return parseFloat(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    RadicalLine.prototype.renderElement = function (node, d, i, g, h) {
        var _a = tool.polar2cart(parseFloat(h.op("_r1")), parseFloat(h.op("_y1"))), x1 = _a[0], y1 = _a[1];
        var _b = tool.polar2cart(parseFloat(h.op("_r2")), parseFloat(h.op("_y2"))), x2 = _b[0], y2 = _b[1];
        node.attr("x1", x1).attr("x2", x2).attr("y1", y1).attr("y2", y2);
    };
    RadicalLine.nodeName = "line";
    return RadicalLine;
}(base_1.BaseElement));
exports.RadicalLine = RadicalLine;
//# sourceMappingURL=radical-line.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/element/radical-line.js
// module id = 1139
// module chunks = 0 1